import { render } from "./informasi_soal.vue?vue&type=template&id=3c5b0b00&scoped=true"
import script from "./informasi_soal.vue?vue&type=script&lang=js"
export * from "./informasi_soal.vue?vue&type=script&lang=js"

import "./informasi_soal.vue?vue&type=style&index=0&id=3c5b0b00&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5b0b00"]])

export default __exports__